import React from 'react';
import Header from './Header';


function MenuGroup() {
    return (

        <>

            <Header />
        </>
    );
}

export default MenuGroup;
